export default __webpack_public_path__ + "static/media/arrow.52c40bc7.svg";